const toggleButton = document.getElementById("language-toggle");
const dropdownMenuLang = document.getElementById("language-menu");

if (toggleButton && dropdownMenuLang) {
  toggleButton.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdownMenuLang.classList.toggle("active");
    toggleButton.classList.toggle("active");

    const iconOpen = toggleButton.querySelector(".dropdown-icon-open");
    const iconClose = toggleButton.querySelector(".dropdown-icon-close");

    if (iconOpen && iconClose) {
      if (dropdownMenuLang.classList.contains("active")) {
        iconOpen.style.display = "block";
        iconClose.style.display = "none";
      } else {
        iconOpen.style.display = "none";
        iconClose.style.display = "block";
      }
    }
  });

  dropdownMenuLang.addEventListener("click", (e) => {
    e.stopPropagation();
  });
}

const navItems = document.querySelectorAll(
  ".header-nav-item_zero, .navigation-list > li"
);
let activeDropdownItem = null;

const closeAllDropdowns = () => {
  navItems.forEach((item) => {
    const dropdown = item.querySelector(".navigation-list-dropdown");
    const iconOpen = item.querySelector(".dropdown-icon-open");
    const iconClose = item.querySelector(".dropdown-icon-close");
    const iconBox = item.querySelector(".dropdown-icon-box");

    if (dropdown) {
      dropdown.classList.remove("active", "is-open");
    }
    if (item) {
      item.classList.remove("active");
    }
    if (iconBox) {
      iconBox.classList.remove("active");
    }

    if (iconOpen && iconClose) {
      iconOpen.style.display = "none";
      iconClose.style.display = "block";
    }
  });

  if (dropdownMenuLang) {
    dropdownMenuLang.classList.remove("active");
  }
  if (toggleButton) {
    toggleButton.classList.remove("active");

    const iconOpen = toggleButton.querySelector(".dropdown-icon-open");
    const iconClose = toggleButton.querySelector(".dropdown-icon-close");
    if (iconOpen && iconClose) {
      iconOpen.style.display = "none";
      iconClose.style.display = "block";
    }
  }
  activeDropdownItem = null;
};

navItems.forEach((item) => {
  const iconBox = item.querySelector(".dropdown-icon-box");
  const dropdown = item.querySelector(".navigation-list-dropdown");
  const iconOpen = item.querySelector(".dropdown-icon-open");
  const iconClose = item.querySelector(".dropdown-icon-close");
  const dropdownIcon = item.querySelector(".dropdown-icon");

  if (!iconBox || !dropdown) return;

  const showDropdown = () => {
    if (activeDropdownItem && activeDropdownItem !== item) {
      const prevDropdown = activeDropdownItem.querySelector(
        ".navigation-list-dropdown"
      );
      const prevIconOpen = activeDropdownItem.querySelector(
        ".dropdown-icon-open"
      );
      const prevIconClose = activeDropdownItem.querySelector(
        ".dropdown-icon-close"
      );
      const prevIconBox =
        activeDropdownItem.querySelector(".dropdown-icon-box");
      const prevDropdownIcon =
        activeDropdownItem.querySelector(".dropdown-icon");

      if (prevDropdown) prevDropdown.classList.remove("active", "is-open");
      if (activeDropdownItem) activeDropdownItem.classList.remove("active");
      if (prevIconBox) prevIconBox.classList.remove("active");
      if (prevDropdownIcon) prevDropdownIcon.classList.remove("active");
      if (prevIconOpen && prevIconClose) {
        prevIconOpen.style.display = "none";
        prevIconClose.style.display = "block";
      }
    }

    item.classList.add("active");
    iconBox.classList.add("active");
    if (dropdownIcon) dropdownIcon.classList.add("active");
    dropdown.classList.add("active", "is-open");
    if (iconOpen && iconClose) {
      iconOpen.style.display = "block";
      iconClose.style.display = "none";
    }
    activeDropdownItem = item;
  };

  const hideDropdown = () => {
    if (
      !item.classList.contains("active") &&
      !dropdown.classList.contains("active")
    )
      return;

    item.classList.remove("active");
    iconBox.classList.remove("active");
    if (dropdownIcon) dropdownIcon.classList.remove("active");
    dropdown.classList.remove("active", "is-open");
    if (iconOpen && iconClose) {
      iconOpen.style.display = "none";
      iconClose.style.display = "block";
    }
    if (activeDropdownItem === item) {
      activeDropdownItem = null;
    }
  };

  item.addEventListener("mouseenter", showDropdown);
  item.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!dropdown.matches(":hover") && !iconBox.matches(":hover")) {
        hideDropdown();
      }
    }, 100);
  });

  iconBox.addEventListener("click", (e) => {
    e.stopPropagation();
    if (
      dropdown.classList.contains("active") ||
      dropdown.classList.contains("is-open")
    ) {
      hideDropdown();
    } else {
      showDropdown();
    }
  });

  iconBox.addEventListener("focus", () => {
    showDropdown();
  });

  dropdown.addEventListener("focusout", () => {
    setTimeout(() => {
      const isStillInside =
        dropdown.contains(document.activeElement) ||
        iconBox.contains(document.activeElement);
      if (!isStillInside) {
        hideDropdown();
      }
    }, 10);
  });

  iconBox.addEventListener("keydown", (e) => {
    // Enter або Space — open/close menu
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (dropdown.classList.contains("active")) {
        hideDropdown();
      } else {
        showDropdown();
        const firstLink = dropdown.querySelector(
          "a, button, [tabindex]:not([tabindex='-1'])"
        );
        if (firstLink) {
          firstLink.focus();
        }
      }
    }
  });

  dropdown.addEventListener("mouseenter", () => {
    if (activeDropdownItem !== item) {
      showDropdown();
    }
  });

  dropdown.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!dropdown.matches(":hover") && !iconBox.matches(":hover")) {
        hideDropdown();
      }
    }, 100);
  });
});

document.addEventListener("click", (e) => {
  const isClickOutsideDropdown =
    activeDropdownItem && !activeDropdownItem.contains(e.target);
  const isClickOutsideLangToggle =
    toggleButton &&
    !toggleButton.contains(e.target) &&
    dropdownMenuLang &&
    !dropdownMenuLang.contains(e.target);

  if (
    isClickOutsideDropdown ||
    (dropdownMenuLang &&
      dropdownMenuLang.classList.contains("active") &&
      isClickOutsideLangToggle)
  ) {
    closeAllDropdowns();
  }
});
